import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitleComponent } from './title.component';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';


@NgModule({
  declarations: [
    TitleComponent
  ],
  imports: [
    CommonModule,
    NxHeadlineModule,
  ],
  exports:[
    TitleComponent
  ]
})
export class TitleModule { }
